<script setup lang="ts">
defineProps<{
  createRoom: () => void
  creatingRoom: boolean
}>()

defineEmits<{
  'open-join-modal': []
  'open-options-modal': []
}>()

defineModel<boolean>('creatingRoom', { default: false })
</script>

<template>
  <div class="flex flex-col items-center justify-center min-h-screen p-6">
    <div class="glass rounded-3xl p-8 max-w-md w-full text-center animate-fade-in">
      <h1 class="text-4xl font-bold text-white mb-2">Adivina la palabra</h1>
      <p class="text-teal-200 mb-8">Adivina que palabra eres con los amegos</p>
      <div class="space-y-4">
        <button
          @click="createRoom"
          :disabled="creatingRoom"
          class="w-full py-4 px-6 bg-accent text-dark font-bold rounded-xl text-lg hover:scale-105 transition-transform disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="creatingRoom" class="inline-block animate-spin mr-2">⏳</span>
          {{ creatingRoom ? 'Creando sala...' : '🎮 Crear Sala' }}
        </button>
        <button
          @click="$emit('open-join-modal')"
          class="w-full py-4 px-6 bg-white/20 text-white font-bold rounded-xl text-lg hover:scale-105 transition-transform"
        >
          🔗 Unirse a Sala
        </button>
        <button
          @click="$emit('open-options-modal')"
          class="w-full py-3 px-6 bg-white/10 text-teal-200 font-semibold rounded-xl hover:bg-white/20 transition-colors"
        >
          ⚙️ Opciones del Juego
        </button>
      </div>
    </div>
  </div>
</template>
